export default {
	person: "Person",
	journeyStage: "Journey Stage",
	since: "Since",
	createAssignment: "Assign Role",
	assignNewPosition: "Assign new journey stage",
	confirmDeleteMessage: "Are you sure you want to delete this assignment? This action cannot be undone.",
	journeyProgressionInfo: "Only journey stages above current level ({currentLevel}) can be selected.",
	createSuccess: "Assignment created successfully!",
	deleteSuccess: "Assignment deleted successfully!",
	createError: "Error creating assignment",
	deleteError: "Error deleting assignment",
};
